export default __webpack_public_path__ + "media/zurb/img/bryan/thumbs/3-6c000b1f0b7a3bc6fdf084e2453a6779.png";